import React from "react";
import { motion } from "framer-motion";
const About = () => {
  return (
    <section id="about" className="section ">
      <h1 className="title ">About </h1>
      <div className="flex flex-col gap-5 lg:flex-row lg:gap-0">
        <div className="flex items-center justify-center w-full ">
          <img
            loading="lazy"
            src={require("../data/img.jpg")}
            alt="Rouatbi"
            className="w-[370px] h-[370px]  shadow-md ph:w-40 rounded-[21% 79% 49% 51% / 44% 37% 63% 56% ] ph:h-40   "
          />
        </div>
        <div className="w-full text-xl lg:text-xl ph:text-xs ">
          <p className="leading-10 ph:leading-5 ">
            I'm a self-taught Developer, I specialise in front-end development
            using
            <span
              href="https://www.codewars.com/users/fedirouatbi"
              target="_blank"
              alt="codewars"
              rel="noreferrer"
              className="z-10  ml-2 text-white after:content-[''] after:bg-sky-400/80 after:absolute   after:-inset-[5px] relative after:-z-10 after:-skew-x-3 after:-skew-y-3"
            >
              Reactjs
            </span>{" "}
            I am always improving myself to stay on top of my field .I'd love to
            work on challenging projects and grow as a Full Stack Developer. In
            my spare time I like to watch movies/series , playing League of
            Legends and watching css and js tricks .
          </p>
          <motion.a
            whileHover={{ scale: 1.1, translateY: -5 }}
            href="mailto: fedirouatbi@gmail.com"
            className="inline-block py-2 text-white mt-14 ph:mt-6 px-7 cta bg-sky-400/80"
          >
            <button className="capitalize">contact Me</button>
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default About;
